import React from 'react';

import { List, ListItem, Typography} from '@mui/material';
import { CardContent, CardMedia } from '@mui/material';
import { PaidPlanActions } from "./PaidPlanActions.jsx";
import { PriceDetails } from "./PriceDetails.jsx";


export const Premium2025Card = ({ plan, sx }) => {
    return (
        <>
            <CardMedia
                component="img"
                height="140"
                image="/images/subscriptionPlanStub.jpg"
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    Премиум
                </Typography>
                <List>
                    <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: '1.3em' }}>
                        <ListItem>Хранение всей истории ваших данных</ListItem>
                        <ListItem>Отображение динамики</ListItem>
                        <ListItem>
                            Персональная аналитика на основе ИИ и научных доказательств
                        </ListItem>

                        {/* TODO Enable when implemented */}
                        {/*<ListItem>*/}
                        {/*    Экспорт результатов обследований, аналитики и выводов в PDF файле*/}
                        {/*</ListItem>*/}
                    </Typography>
                </List>
            </CardContent>
            <PaidPlanActions plan={plan} PriceDetailsComponent={PriceDetails} />
        </>
    )
}
